import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import BundlesHeader from "./BundlesHeader";
import BundlesDetailsTab from "./BundlesDetailsTab";
import axios from "axios";
import { SessionContext } from '../../common/SessionContext';

function BundlesWrap() {

    const { session } = useContext(SessionContext);
    const currentCurrency = session.currency;

    // API configuration constants
    const API_URL = `${process.env.REACT_APP_API_FOLDER}get_bundles/`;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    // State management for data, loading status, and error handling
    const [bundles, setBundles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        /**
         * Fetches data from the API with authentication token
         */

        const fetchData = async () => {
            try {
                const response = await axios.get(API_URL, {
                    headers: { "X-API-TOKEN": API_TOKEN }
                });

                // Extract the nested object matching the currentCurrency
                const bundlesForCurrency = response.data[currentCurrency];

                // Update component state with the filtered data
                setBundles(bundlesForCurrency || []); // Default to an empty array if undefined
                setLoading(false);
            } catch (error) {
                console.error("API Error:", error);
                setError(error.message || "Failed to fetch API");
                setLoading(false);
            }
        };

        fetchData();
    }, []); // Empty dependency array means this effect runs once on mount

    console.log(error);

    return (
        <>
            <div className="package-details-wrapper pt-110">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="tour-package-details">
                                <BundlesHeader />
                                <BundlesDetailsTab bundles={bundles} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="package-sidebar">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BundlesWrap;
